import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Plant scope for a single Search/Download request, never shared between modules. */
export const REQUEST_TENANTS = new HttpContextToken<readonly string[]>((): readonly string[] => []);

export const requestTenantsContext = (plants?: null | readonly string[] | string): HttpContext =>
  new HttpContext().set(
    REQUEST_TENANTS,
    typeof plants === 'string' ? plants.split(',') : (plants ?? []),
  );
